import { fromJS, List } from 'immutable'
import { Hours } from 'components/Customize/Availability/Constants'

function getAvailabilityFromEmbed(embed) {
  const { openHours } = embed.configuration.theme
  return fromJS(openHours)
    .map((hours) => Hours({
      opens: hours.get('opens'),
      closes: hours.get('closes'),
      dayOfWeek: hours.get('dayOfWeek')
    }))
}

class AvailabilityStore extends Marty.Store {
  constructor(options) {
    super(options)
    this.state = List()
  }

  getAvailability() {
    return this.fetch({
      id: 'getAvailability',
      dependsOn: [
        this.app.stores.OrgStore.getOrFetchCurrentOrg(),
        this.app.stores.DefaultEmbedStore.getOrFetchCurrentDefaultEmbed()
      ],
      locally() {
        const orgId = this.app.stores.OrgStore.getCurrentOrg().id
        const embed = this.app.stores.DefaultEmbedStore.state.embedByOrgId[orgId]
        return getAvailabilityFromEmbed(embed)
      }
    })
  }
}

export default AvailabilityStore



// WEBPACK FOOTER //
// ./src/scripts/stores/AvailabilityStore.js